import { defineNuxtPlugin, useHead, useRoute, useRuntimeConfig } from "#imports";


export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		const validRoutes = ['/lp/anima'];
		const route = useRoute();
		const runtimeConfig = useRuntimeConfig();
		// if (validRoutes.includes(route.path) && ['local', 'dev'].includes(runtimeConfig.public.appEnv)) {
		// 	useHead(
		// 		{
		// 			script: [
		// 				{
		// 					hid: 'jivochat',
		// 					src: `//code.jivosite.com/widget/odLrBybfTT`,
		// 					async: true
		// 				}
		// 			]
		// 		}
		// 	);
		// }
	}
});
